import { useLocation } from "react-router-dom";
import { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import NavLink from "./navLink";

import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import { setTabData } from "../../redux/programs/ProgramsAction";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const SideNav = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [showDetailView, setShowDetailView] = useState(false);
  const closeNav = (label) => {
    if (label === "Programs") {
      dispatch(setTabData("inperson"));
    }
    setShowDetailView(false);
  };
  const openNav = () => {
    setShowDetailView(true);
  };
  const currentPage = pathname.split("/").slice(-1)[0];

  const handleFreshlyEvent = () => {
    eventTrack("Redirection To Freshly Website", "From Meal Services button in header", "Redirection");
    eventTrackGA4("Redirection To Freshly Website", "From Meal Services button in header", "Redirection");
    setShowDetailView(false);
  };

  return (
    <>
      <div className="ham-icon">
        <FiMenu className="ham-menu" style={CONSTANTS.EXTRA_BIG_ICON} onClick={openNav} />
      </div>
      {showDetailView ? (
        <div className="sidenav">
          <div className="options">
            {CONSTANTS.NAV_ITEMS.map(({ label, pathName, url }) => {
              if (label === "Shop") {
                return (
                  <a
                    className="option"
                    target="_blank"
                    href={url}
                    rel="noreferrer noopener"
                    onClick={handleFreshlyEvent}
                  >
                    {label}
                  </a>
                );
              } else {
                return (
                  <NavLink
                    key={pathName}
                    label={label}
                    pathName={pathName}
                    isSelected={currentPage == pathName}
                    handleClick={() => {
                      closeNav(label);
                    }}
                  />
                );
              }
            })}
          </div>
        </div>
      ) : null}

      {/* {showDetailView ? (
        <div className="sidenav">
          <div className="options">
            <Link
              style={{ color: "white" }}
              className={`${currentPage === "/" ? "selected" : ""}  option`}
              to="/"
              onClick={closeNav}
            >
              Overview
            </Link>

            <Link
              style={{ color: "white" }}
              className={`${currentPage === "/newStartHere" ? "selected" : ""}  option`}
              to="/newStartHere"
              onClick={closeNav}
            >
              New? Start Here
            </Link>

            <Link
              style={{ color: "white" }}
              onClick={() => {
                dispatch(setTabData("inperson"));
              }}
              className={`${currentPage === "/programs" ? "selected" : ""}  option`}
              to="/programs"
              onClick={closeNav}
            >
              Programs
            </Link>
            <Link
              style={{ color: "white" }}
              className={`${currentPage === "/clients" ? "selected" : ""}  option`}
              to="/clients"
              onClick={closeNav}
            >
              Clients
            </Link>
            <Link
              className={`${currentPage === "/mealServices" ? "selected" : ""}  option`}
              to="/mealServices"
              onClick={closeNav}
            >
              Meal Services
            </Link>
            <a
              className="option"
              target="_blank"
              href={CONSTANTS.shopUrl}
              rel="noreferrer noopener"
              onClick={handleFreshlyEvent}
            >
              Shop
            </a>
            <Link
              style={{ color: "white" }}
              className={`${currentPage === "/updates" ? "selected" : ""}  option`}
              to="/updates"
              onClick={closeNav}
            >
              Updates
            </Link>
            <Link
              style={{ color: "white" }}
              className={`${currentPage === "/careers" ? "selected" : ""}  option`}
              to="/careers"
              onClick={closeNav}
            >
              Careers
            </Link>
            <Link
              style={{ color: "white" }}
              className={`${currentPage === "/contact" ? "selected" : ""}  option`}
              to="/contact"
              onClick={closeNav}
            >
              Contact
            </Link>
          </div>
        </div>
      ) : null} */}
    </>
  );
};
export default SideNav;
